import React, { FC } from 'react';
import { ExpertiseComponentContainer, FormContainer } from '../../../../styles/styled';
import CreateNmsMember from '../../../CreateNmsMember';
import { NmsMemberType } from '../../../NmsMembers/types';

type NmsEditComponentProps = {
  currentNms: NmsMemberType | null;
  handleRefreshNmsData: () => Promise<void>;
};

export const NmsEditComponent: FC<NmsEditComponentProps> = ({ currentNms, handleRefreshNmsData }) => {
  return (
    <ExpertiseComponentContainer>
      <FormContainer padding="20px" background={'#fff'}>
        <CreateNmsMember editNms currentNms={currentNms} handleRefreshNmsData={handleRefreshNmsData} />
      </FormContainer>
    </ExpertiseComponentContainer>
  );
};
